<template>
  <div>
    <section class="my-4 my-lg-5">
      <b-row align-h="center">
        <b-col cols="11" md="8" lg="5">
          <b-input-group
            class="align-items-center border border-platform rounded p-2 shadow search-input"
            :style="{ borderWidth: '4px !important', borderRadius: '5px' }"
          >
            <b-form-input
              v-model="str"
              class="border-0 px-2 text-14 text-md-18"
              placeholder="검색어를 입력하세요."
              @keypress.enter="search(str)"
            />
            <template #append>
              <b-btn variant="text p-0" @click="search(str)">
                <i class="icon icon-search text-24 text-platform" />
              </b-btn>
            </template>
          </b-input-group>
        </b-col>
      </b-row>
    </section>
    <section>
      <middle-container class="mb-5 pb-lg-3">
        <!-- <b-row class="platform-select-category d-flex d-lg-flex align-items-center justify-content-between mx-n1">
          <b-col cols="6" class="px-1 text-center" v-for="(item, i) in categories" :key="i">
            <input type="radio" class="d-none" :id="item.value" :value="item.value" name="category" v-model="category" />
            <label :for="item.value" class="w-100 py-2 text-nowrap cursor-pointer">
              <i class="icon icon-hbg" v-if="item.value === 'ALL'" />
              {{ item.text }}
            </label>
          </b-col>
        </b-row> -->
        <template v-if="pending.search">
          <div class="text-center p-4">
            <b-spinner variant="platform" />
          </div>
        </template>
        <template v-else-if="items">
          <section class="mt-3 mb-5">
            <header
              class="mb-3 pb-3 d-lg-flex align-items-center justify-content-between border-bottom border-platform"
            >
              <h2 class="text-13 text-md-18">
                <strong class="fw-600">{{ selectedCateogry }}</strong>
                키워드 "{{ query.query }}"에 대한
                <template v-if="items.length">
                  {{ items.length }}개의 검색결과를 찾았습니다.
                </template>
                <template v-else-if="!items || !items.length">
                  검색결과가 없습니다.
                </template>
              </h2>
              <!-- <b-row align-h="end" class="mt-2 mt-lg-0">
                <b-col cols="7" lg="12">
                  <div class="d-lg-flex align-items-center justify-content-center">
                    <b-input-group class="align-items-center border rounded-sm px-2 mr-2">
                    <b-form-input v-model="str2" class="border-0 px-2" placeholder="결과내 재검색" @keypress.enter="search(str2)" />
                    <template #append>
                      <b-btn variant="text p-0" @click="search(str)">
                        <i class="icon icon-search text-18 text-gray-59" />
                      </b-btn>
                    </template>
                  </b-input-group>
                    <div class="d-none d-lg-flex btn-group">
                      <label
                        v-for="item in listTypes"
                        :key="item"
                        class="platform-select-view-type btn btn-text p-0 d-flex align-items-center p-1"
                        :class="{ active: listType === item }"
                      >
                        <input class="d-none" type="radio" name="list-type" :value="item" v-model="listType" />
                        <i :class="`icon icon-view-${item} text-18 text-gray-59`" />
                      </label>
                    </div>
                  </div>
                </b-col>
              </b-row> -->
            </header>
            <template v-if="items && items.length">
              <b-row align-v="start">
                <b-col
                  cols="12"
                  md="6"
                  class="mb-3"
                  :lg="listTypeColumn"
                  v-for="(item, i) in items"
                  :key="i"
                >
                  <article
                    :class="`py-3 article article-${listType} cursor-pointer`"
                    @click="
                      $router.push({
                        path: `/process-preview`,
                        query: {
                          processId: item.processId,
                          editorType: 'process',
                        },
                      })
                    "
                  >
                    <header
                      class="pt-2 mb-1 d-flex algin-items-center justify-content-between"
                    >
                      <h3 class="text-16 text-md-18 fw-400">
                        [{{ item.fieldName }}] {{ item.processName }}
                      </h3>
                    </header>
                    <section class="py-2">
                      <p class="m-0 p-0 text-14 text-gray-6">
                        {{ getDate(item.createdDate) }} | {{ item.userName }}
                      </p>
                    </section>
                    <b-row class="pt-3" align-v="start">
                      <!-- <b-col
                        :cols="listType === 'list' ? 12 : 12"
                        :lg="listType === 'list' ? 6 : 12"
                        :order="listType === 'list' ? 1 : 1"
                        :order-md="listType === 'list' ? 0 : 1"
                        class="mb-3"
                      >
                        <b-row align-v="start" class="mx-n1">
                          <b-col class="col-20 px-1" v-for="(item, i) in 5" :key="i">
                            <div class="bg-img ratio-100 bg-gray-f5" />
                          </b-col>
                        </b-row>
                      </b-col> -->
                      <b-col
                        :cols="listType === 'list' ? 6 : 12"
                        :lg="listType === 'list' ? 6 : 12"
                        :order="listType === 'list' ? 0 : 0"
                        :order-md="listType === 'list' ? 1 : 0"
                        class="mb-3"
                      >
                        <b-row align-v="start" class="mx-n1">
                          <b-col
                            cols="6"
                            :lg="3"
                            class="px-1 mb-1"
                            v-for="(p, l) in process"
                            :key="l"
                          >
                            <div
                              class="text-center d-flex align-items-center justify-content-center py-2"
                              :class="item[p.bind] ? 'bg-dark' : 'bg-gray-9'"
                            >
                              <i
                                :class="`icon icon-platform-${p.icon} mr-2 icon-20`"
                              ></i>
                              <span class="text-white text-12 text-nowrap">
                                {{ p.title }}
                              </span>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </article>
                </b-col>
              </b-row>
              <div class="mt-5 d-flex justify-content-center">
                <b-pagination
                  :total-rows="page.totalElements"
                  :per-page="page.perPage"
                  v-model="page.pageNo"
                  @change="
                    $router.push({
                      path: '/platform/search',
                      query: { ...query, pageNo: $event },
                    })
                  "
                  hide-goto-end-buttons
                  class="platform-pagination mb-0"
                  prev-class="prev-btn mr-2"
                  next-class="next-btn ml-2"
                  page-class="mx-1"
                >
                  <template #prev-text>
                    <i class="icon icon-prev-arrow text-20 mb-n1 text-white" />
                  </template>
                  <template #next-text>
                    <i class="icon icon-next-arrow text-20 mb-n1 text-white" />
                  </template>
                </b-pagination>
                <!-- <div class="d-block d-lg-none">
                  <b-btn
                    variant="text text-gray-6 text-14"
                    @click="
                      $router.push({
                        path: '/platform/search',
                        query: { ...query, pageNo: page.pageNo + 1 },
                      })
                    "
                  >
                    MORE
                    <span class="d-block bg-platform mb-3" :style="{ width: '40px', height: '2px' }"></span>
                  </b-btn>
                </div> -->
              </div>
            </template>
            <template v-else>
              <div
                class="border d-flex flex-column py-5 align-items-center justify-content-center"
              >
                <i
                  class="icon icon-search text-platform text-48 text-md-56s"
                  :style="{ opacity: 0.4 }"
                />
                <h1 class="mt-1 text-20 text-md-24" :style="{ opacity: 0.4 }">
                  No Results Found
                </h1>
              </div>
            </template>
          </section>
        </template>
        <template v-else-if="!pending.search && !query.query"> </template>
        <template v-else>
          <div
            class="my-5 py-md-5 text-center d-flex flex-column align-items-center"
          >
            <img
              :src="require('@/assets/protocol/noData.svg')"
              alt="데이터가 없음 표시 이미지"
              :style="{ width: '96px' }"
            />
            <h1 class="mt-3 text-16 text-gray-6 lh-180">권한이 없습니다</h1>
            <small>공정도와 프로토콜 검색에는 계정 권한이 필요합니다.</small>
            <div class="mt-4 d-flex align-items-center text-center">
              <b-btn variant="outline-platform" to="/account/signup"
                >회원가입</b-btn
              >
              <span class="mx-3">혹은</span>
              <b-btn variant="platform " to="/account/login">로그인</b-btn>
            </div>
          </div>
        </template>
      </middle-container>
    </section>
  </div>
</template>

<script>
import MiddleContainer from "@/components/platform/MiddleContainer";
export default {
  components: {
    MiddleContainer,
  },
  data() {
    return {
      str: null,
      pending: {
        search: false,
      },
      category: "TREE",
      categories: [
        {
          text: "공정도",
          value: "TREE",
        },

        {
          text: "프로토콜",
          value: "PROTOCOL",
        },
      ],
      listType: "card",
      // listTypes: ["list", "card"],
      items: null,
      page: null,

      process: [
        {
          title: "공정도",
          icon: "process",
          bind: "processActive",
        },
        {
          title: "분석목적",
          icon: "target",
          bind: "purposeActive",
        },
        {
          title: "분석 map",
          icon: "map",
          bind: "mapActive",
        },
        {
          title: "프로토콜",
          icon: "protocol",
          bind: "protocolActive",
        },
      ],
    };
  },
  computed: {
    query() {
      return this.$route.query;
    },
    selectedCateogry() {
      return this.categories.find((c) => c.value === this.category).text;
    },
    listTypeColumn() {
      const types = {
        list: 6,
        card: 6,
      };
      return types[this.listType];
    },
  },
  watch: {
    query(n) {
      this.getItems(n);
    },
  },
  mounted() {
    if (this.query.query) {
      this.str = this.query.query;
      this.getItems(this.query);
    }
  },
  methods: {
    async getItems({ pageNo = 1, perPage = 10 }) {
      this.pending.search = true;
      const data = await this.$wApi.process.search({
        ...this.query,
        pageNo: pageNo - 1,
        perPage,
      });
      if (data) {
        const { content, size, number, numberOfElements, totalElements } = data;
        this.items = content;
        // console.log("this.items", this.items);

        this.page = {
          perPage: size,
          pageNo: number + 1,
          numberOfElements,
          totalElements,
        };
      }
      this.pending.search = false;
    },
    search(query) {
      this.$router.push({
        path: "/platform/search",
        query: {
          ...this.query,
          query: query,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input {
  .form-control {
    &::placeholder {
      color: #017fba;
      font-size: 18px;
    }
  }
}

article.article {
  border: 1px solid #e6e6e6;
  &.article-list {
    @media all and (min-width: 992px) {
      border-left: 0;
      border-right: 0;
      border-top: 0;
    }
  }
  &.article-card {
    margin-bottom: 18px;
    padding: 12px;
    @media all and (min-width: 992px) {
      margin-bottom: 24px;
      padding: 12px 20px;
    }
  }
  @media all and (max-width: 992px) {
    margin-bottom: 18px;
    padding: 12px;
  }
}
</style>
